import {FC, useContext, createContext} from 'react'

type PaymentMethodContextType = {
  showWineClubSelection: boolean
}

const PaymentMethodContext = createContext<PaymentMethodContextType>({
  showWineClubSelection: false,
})

interface Props {
  children: React.ReactNode
  showWineClubSelection?: boolean
}

export const PaymentMethodProvider: FC<Props> = ({children, showWineClubSelection = false}) => {
  return (
    <PaymentMethodContext.Provider
      value={{
        showWineClubSelection,
      }}
    >
      {children}
    </PaymentMethodContext.Provider>
  )
}
export const usePaymentMethodContext = () => useContext(PaymentMethodContext)
